<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="teacher-page">
    <Header light />
    <section
      class="teacher-banner"
      :style="bannerStyle"
      aria-label="老师介绍"
    ></section>
    <main class="teacher-main">
      <section v-for="group in groups" :key="group.title" class="teacher-group">
        <div class="teacher-group-heading">
          <span>{{ group.eyebrow }}</span>
          <h2>{{ group.title }}</h2>
          <p>{{ group.description }}</p>
        </div>
        <div class="teacher-grid">
          <article
            v-for="teacher in group.teachers"
            :key="teacher.name"
            class="teacher-profile-card"
            tabindex="0"
          >
            <div class="teacher-profile-card-inner">
              <div class="teacher-profile-card-face teacher-profile-card-front">
                <img :src="teacher.image" :alt="teacher.name" />
              </div>
              <div class="teacher-profile-card-face teacher-profile-card-back">
                <span>{{ teacher.name }}</span>
                <h3>{{ teacher.role }}</h3>
                <p>{{ teacher.detail }}</p>
              </div>
            </div>
          </article>
        </div>
      </section>
    </main>
    <Footer />
  </div>
</template>

<script setup>
import Header from "../components/layout/Header.vue";
import Footer from "../components/layout/Footer.vue";
import "../assets/css/Teacher.css";

const imageRoot = "/images/teachers/1/";
const teacher = (name, role, detail, file = `${name}.jpg`) => ({
  name,
  role,
  detail,
  image: imageRoot + file,
});

const groups = [
  {
    // eyebrow: "01 / TEACHING & R&D",
    title: "教学研发导师团队",
    description: "来自一线企业的技术专家，把真实项目经验带进课堂。",
    teachers: [
      teacher(
        "Mr.Han老师",
        "前 Oracle 核心架构师 · 8年云计算运维专家",
        "前 Oracle 北京研发中心核心架构师，拥有 8 年一线 IT 运维与云计算架构经验，曾为银行、运营商、制造业等 50+ 行业标杆企业提供架构咨询与内训服务。深耕职业教育多年，培养超 1000 名中高级 IT 人才，打造 JAVA 开发筑基与大模型应用落地双主线课程。",
      ),
      teacher(
        "常胜老师",
        "字节跳动前资深研发工程师 · 分布式架构导师",
        "拥有 10 年一线科技与互联网企业分布式架构设计经验，曾任职于中科软、浪潮、字节跳动，深度主导千万级业务架构设计与研发落地。坚持实战为王、结果导向，擅长把企业真实项目拆解为可落地的学习模块。",
      ),
      teacher(
        "宇畔老师",
        "大数据与后端架构实战导师",
        "拥有多年企业级大数据与后端架构实战经验，精通 JAVA、SpringBoot、微服务、MySQL、Redis、Linux、Docker 与 Nginx，具备从 0 到 1 搭建企业级业务系统的能力，坚持企业场景化实战教学。",
      ),
      teacher(
        "南枫老师",
        "品牌设计总监 · 设计教学实战导师",
        "拥有 10 年设计行业经验与 5 年设计教学沉淀，曾服务多家大型企业，擅长全案 VI、电商视觉与商业互动设计。精通 PS、AI、PR、剪映及主流 AI 工具，坚持以真实商业项目开展实战训练。",
      ),
      teacher(
        "景程老师",
        "前阿里资深 AI 应用架构师",
        "拥有 10 年企业级 AI+JAVA 全栈研发经验，曾任阿里核心业务线资深 AI 应用架构师，精通微服务、大模型 API 集成、RAG 检索增强生成等技术，将大厂研发流程与真实业务场景融入教学。",
      ),
      teacher(
        "启航老师",
        "AI 运维工程师培养导师 · 98%学员就业率",
        "拥有 10 年企业级运维与 AI 运维实战经验，累计培养超 2000 名 AI 运维与云计算工程师。精通传统运维、云原生与智能运维全链路技术，坚持零基础友好、结果导向，为学员定制学习路径并全程跟进。",
      ),
      teacher(
        "乐远老师",
        "前腾讯高级 JAVA 研发工程师",
        "拥有 8 年互联网大厂 JAVA 研发与架构经验，曾参与腾讯亿级日活业务的高并发分布式架构设计与优化。坚持技术深度与实战落地并重，帮助学员建立分布式架构思维和解决高并发问题的能力。",
      ),
      teacher(
        "小峰老师",
        "AI+JAVA 全栈开发转型导师",
        "拥有 15 年大型企业 JAVA 开发与 AI 应用研发经验，累计培养 3000+ 零基础学员。独创阶梯式零基础教学体系，将复杂知识拆解为渐进式模块，帮助学员从零建立完整技术体系。",
      ),
      teacher(
        "阿凯老师",
        "4A 广告公司 AI 设计总监",
        "拥有 12 年商业视觉设计与 AI 设计经验，服务过宝马、华为、欧莱雅等 50+ 世界五百强品牌，擅长品牌 VI、电商视觉与 AI 商业创作，专注把头部品牌商业设计经验转化为易学易用的实战方法。",
      ),
      teacher(
        "博帆老师",
        "前百度 AI 生态核心研发工程师",
        "拥有多年大模型全链路研发与教学经验，曾参与百亿级大模型预训练、RLHF、LoRA 适配等研发落地，精通大模型原理、分布式训练、多模态对齐、RAG 与推理优化，致力于还原大厂研发流程。",
      ),
    ],
  },
  {
    // eyebrow: "02 / CAREER DEVELOPMENT",
    title: "职业发展导师团队",
    description: "从学习规划到入职发展，提供全周期的职业陪伴。",
    teachers: [
      teacher(
        "远航老师",
        "前互联网大厂 HRBP · IT 就业导师",
        "拥有 10 年 IT 行业人力资源与就业辅导经验，曾任互联网大厂 HRBP，累计辅导 3000+ 学员。精通技术岗位招聘标准与面试逻辑，擅长简历优化、面试模拟、offer 谈判和入职跟进。",
      ),
      teacher(
        "乐途老师",
        "零基础转行就业引路人",
        "拥有 10 年 IT 职业教育就业辅导经验，累计辅导 2500+ 零基础与跨行业学员，就业率达 96%。擅长定制职业规划与学习路径，并通过简历、面试、offer 选择等全流程一对一辅导帮助学员完成职业转型。",
      ),
      teacher(
        "星文老师",
        "AI 赛道高薪岗位匹配师",
        "拥有 8 年 AI 行业就业辅导经验，熟悉 AI 设计、AI 运维、智能应用开发、大模型研发等岗位需求，累计辅导 1800+ AI 方向学员，就业率 92%，为学员定制就业提升方案，精准匹配高薪岗位。",
      ),
      teacher(
        "正阳老师",
        "前美团技术面试官 · JAVA 面试专家",
        "拥有 12 年 JAVA 招聘、面试与就业辅导经验，曾任美团技术面试官，累计面试 2000+ 候选人。擅长搭建 JAVA 面试知识体系，通过真实场景模拟面试帮助学员攻克面试难点。",
      ),
      teacher(
        "小山老师",
        "学员全周期职业发展护航师",
        "拥有 12 年 IT 职业教育就业管理经验，累计服务 4000+ 学员，就业率达 95%。打造从入学到入职、甚至入职后 1 年的全周期职业护航体系，持续提供简历、面试、offer 与职场发展咨询。",
      ),
    ],
  },
];

const bannerStyle = {
  backgroundImage: 'url("/images/teachers/人物合集-1.jpg")',
};
</script>
